import React, { useState } from 'react';
import './ScratchCard.css';

function ScratchCard() {
  const [formData, setFormData] = useState({
    network: 'safaricom',
    scratchAmount: '',
    discountedAmount: '',
    phone: '',
    confirmPhone: '',
    names: '',
    file: null,
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success' or 'error'

  const handleAmountChange = (e) => {
    const amount = e.target.value;
    setFormData({
      ...formData,
      scratchAmount: amount,
      discountedAmount: amount ? (amount * 0.9).toFixed(2) : '',
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        file: file,
      });
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const file = e.dataTransfer.files[0];
    if (file) {
      setFormData({
        ...formData,
        file: file,
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.scratchAmount) {
      newErrors.scratchAmount = 'Scratch card amount is required';
    }
    if (!formData.phone) {
      newErrors.phone = 'Phone number is required';
    }
    if (!formData.confirmPhone) {
      newErrors.confirmPhone = 'Confirm phone number is required';
    }
    if (formData.phone !== formData.confirmPhone) {
      newErrors.confirmPhone = 'Phone numbers do not match';
    }
    if (!formData.names) {
      newErrors.names = 'M-Pesa names are required';
    }
    if (!formData.file) {
      newErrors.file = 'Please upload a scratch card image';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      setIsSubmitting(true);
      
      // WhatsApp Number (Replace with the actual recipient number)
      const whatsappNumber = '254734634254'; 
      
      // Construct the message
      const message = `*New Scratch Card Conversion Request*
-----------------------------------
*Network:* ${formData.network.toUpperCase()}
*Scratch Amount:* KES ${formData.scratchAmount}
*Amount to Receive:* KES ${formData.discountedAmount}
*Phone Number:* ${formData.phone}
*M-Pesa Names:* ${formData.names}
-----------------------------------
_Note: Please ensure the scratch card image is sent along with this message._`;

      // Encode the message for URL
      const encodedMessage = encodeURIComponent(message);
      
      // Create the WhatsApp link
      const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

      // Open WhatsApp in a new tab
      window.open(whatsappLink, '_blank');

      setSubmitStatus('success');
      setIsSubmitting(false);
      
      // Optional: Reset form after submission
      /*
      setFormData({
        network: 'safaricom',
        scratchAmount: '',
        discountedAmount: '',
        phone: '',
        confirmPhone: '',
        names: '',
        file: null,
      });
      */
    }
  };

  return (
    <div className="scratch-card-page">
      <div className="scratch-card-header">
        <div className="container">
          <h1>Convert Scratch Card Airtime to Cash Online in Kenya</h1>
          <p className="subtitle">Easily convert your Safaricom or Airtel scratch card airtime to cash with instant M-Pesa payments</p>
        </div>
      </div>

      <div className="container">
        <div className="form-section">
          <h2>Convert Your Airtime to Cash Now</h2>

          <form onSubmit={handleSubmit} className="conversion-form">
            <div className="form-group">
              <label htmlFor="network">Select Network:</label>
              <select
                id="network"
                name="network"
                value={formData.network}
                onChange={handleInputChange}
              >
                <option value="safaricom">Safaricom</option>
                <option value="airtel">Airtel</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="scratchAmount">Enter Amount Present on the Scratch Card:</label>
              <input
                type="number"
                id="scratchAmount"
                name="scratchAmount"
                value={formData.scratchAmount}
                onChange={handleAmountChange}
                placeholder="Enter amount"
                min="0"
              />
              {errors.scratchAmount && <span className="error">{errors.scratchAmount}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="discountedAmount">Amount You Will Receive:</label>
              <input
                type="text"
                id="discountedAmount"
                name="discountedAmount"
                value={formData.discountedAmount}
                readOnly
                placeholder="Amount will be calculated"
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone Number to Receive Payment:</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="Enter phone number"
              />
              {errors.phone && <span className="error">{errors.phone}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="confirmPhone">Confirm Phone Number to Receive Payment:</label>
              <input
                type="tel"
                id="confirmPhone"
                name="confirmPhone"
                value={formData.confirmPhone}
                onChange={handleInputChange}
                placeholder="Confirm phone number"
              />
              {errors.confirmPhone && <span className="error">{errors.confirmPhone}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="names">M-Pesa Names:</label>
              <input
                type="text"
                id="names"
                name="names"
                value={formData.names}
                onChange={handleInputChange}
                placeholder="Enter M-Pesa account names"
              />
              {errors.names && <span className="error">{errors.names}</span>}
            </div>

            <div className="form-group">
              <label>UPLOAD AIRTIME SCRATCH CARD:</label>
              <div
                className="file-upload-area"
                onDragOver={handleDragOver}
                onDrop={handleDrop}
              >
                <input
                  type="file"
                  id="fileInput"
                  name="file"
                  onChange={handleFileChange}
                  accept="image/*"
                  style={{ display: 'none' }}
                />
                <label htmlFor="fileInput" className="file-upload-label">
                  Upload a file
                </label>
                <p className="drag-drop-text">or drag and drop</p>
                <p className="file-info">PNG, JPG, GIF up to 10MB</p>
                {formData.file && (
                  <p className="file-selected">File selected: {formData.file.name}</p>
                )}
              </div>
              {errors.file && <span className="error">{errors.file}</span>}
            </div>

            <button 
              type="submit" 
              className="submit-btn" 
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Opening WhatsApp...' : 'Convert Airtime to Cash via WhatsApp'}
            </button>
            
            {submitStatus === 'success' && (
              <p className="success-message">Redirecting to WhatsApp... Please remember to attach your scratch card image in the chat.</p>
            )}
          </form>
        </div>

        <div className="faq-section">
          <h2>Frequently Asked Questions</h2>

          <div className="faq-item">
            <h3>How to convert scratch card airtime to cash online?</h3>
            <p>
              Simply select your network, enter the scratch card amount, provide your M-Pesa details, and upload a clear photo of your scratch card. We'll process your conversion quickly.
            </p>
          </div>

          <div className="faq-item">
            <h3>How to convert scratch card airtime to cash in Kenya?</h3>
            <p>
              Our service is specifically designed for Kenyan customers. We accept Safaricom and Airtel Kenya scratch cards and pay out directly to your M-Pesa account.
            </p>
          </div>

          <div className="faq-item">
            <h3>How to convert scratch card airtime to cash Airtel?</h3>
            <p>
              Select "Airtel" as your network provider, enter the amount on your Airtel scratch card, provide your M-Pesa details, and upload the scratch card image for processing.
            </p>
          </div>
        </div>

       
        <div className="accepted-sources-section">
          <h2>ACCEPTED AIRTIME TO MPESA SOURCES:</h2>

          <ul className="sources-list">
            <li>Airtime gifts.</li>
            <li>Surplus airtime from work.</li>
            <li>Airtime won on radio promotions.</li>
            <li>Airtime bought from the bank or mobile money </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ScratchCard;
